import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from '../http/http.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NcdclientService {

  payload = new BehaviorSubject<any>(null);
        documentID = new BehaviorSubject<any>(null);

        constructor( private httpService: HttpService) { }

        setDocument(id) {
                this.documentID.next(id);
        }

        getDocumentID() {
                return this.documentID;
        }

        // setPayload(data) {
        //         this.payload.next(data);
        // }

        // getPayload() {
        //         return this.payload;
        // }

        getAllIssueListData(object) {
                var issueListData = {
                        URL: "ncdIssues/getAllNcdIssuesList",
                        DATA: object
                }
                return this.httpService.post(issueListData);
        }

        getUniqueIssueSeries(object) {
                var request = {
                        URL: 'ncdIssues/getUniqueIssueSeries',
                        DATA: object
                }
                return this.httpService.post(request);
        }

        getPartATermsheetData() {
                var termsheetList = {
                        URL: "ncdIssues/getPartATermsheetFields",
                }
                return this.httpService.get(termsheetList);
        }

        addIssue(object) {
                var request = {
                        URL: "ncdIssues/saveIssue",
                        DATA: object
                }
                return this.httpService.post(request);
        }

        getPartBTermsheetData() {
                var termsheetList = {
                        URL: "ncdIssues/getPartBTermsheetFields",
                }
                return this.httpService.get(termsheetList);
        }

        addPartB(object) {
                var request = {
                        URL: "ncdIssues/savePartB",
                        DATA: object
                }
                return this.httpService.post(request);
        }


        getPartCTermsheetData() {
                var termsheetList = {
                        URL: "ncdIssues/getPartBTermsheetFields",
                }
                return this.httpService.get(termsheetList);
        }

        addPartC(object, id) {
                var request = {
                        URL: 'ncdIssues/updatePartC/' + id,
                        DATA: object
                }
                return this.httpService.post(request);
        }

        // ============UPDATE=========
        getIssueDetailsById(id) {
                var request = {
                        URL: 'ncdTermsheet/getIssueDetailsById/' + id
                }
                return this.httpService.get(request);
        }

        updateIssue(object, id) {
                var request = {
                        URL: 'ncdIssues/updateIssue/' + id,
                        DATA: object
                }
                return this.httpService.post(request);
        }


        // ====================DELETE==========

        removeIssue(_id) {
                var request = {
                        URL: "ncdIssues/deleteIssue/" + _id
                }
                return this.httpService.get(request);
        }

        addAdditionalFields(object, id) {
                var request = {
                        URL: 'ncdIssues/updateAdditionalFields/' + id,
                        DATA: object
                }
                return this.httpService.post(request);
        }

        getAdditionalFields(id) {
                var request = {
                        URL: 'ncdIssues/getAdditionalFields/' + id
                }
                return this.httpService.get(request);
        }

        importCSV(file, id) {
                var request = {
                        URL: 'ncdIssues/importNseData/' + id,
                        File: file
                }
                return this.httpService.post(request);
        }

        getUploadedDoc(id) {
                var request = {
                        URL: 'uploaded/files/' + id,
                }
                return this.httpService.get(request);
        }

        UploadNCDDoc(payload, id) {
                var request = {
                        URL: 'upload/ncd/doc',
                }
                return this.httpService.upload(request, payload, id);
        }

        uploadMultipleDoc(payload) {
                var request = {
                        URL: 'upload/multiple/docs',
                }
                return this.httpService.uploadMultipleDocs(request, payload);
        }

        uploadDocs(payload) {
                var request = {
                        URL: 'upload/doccuments',
                        DATA: payload
                }
                return this.httpService.post(request);
        }
        updateDocs(payload, id) {
                var request = {
                        URL: 'update/documents/' + id,
                        DATA: payload
                }
                return this.httpService.post(request);
        }

        addDocumentGenrationMasterSetup(payload) {
                var request = {
                        URL: 'document/master/setup',
                        DATA: payload
                }
                return this.httpService.post(request);
        }

        getDocumentGenrationMasterSetup() {
                var request = {
                        URL: 'document/master/setup',
                }
                return this.httpService.get(request);
        }

        getDocListWithAccessRightsForLoggedInUser() {
                var request = {
                        URL: 'ncd/getAccessRightsForLoggedInUser',
                }
                return this.httpService.get(request);
        }

        
        // getUserList() {
        //         var request = {
        //                 URL: 'document/master/setup/userList',
        //         }
        //         return this.httpService.get(request);
        // }
        getLib() {
                var request = {
                        URL: 'document/master/setup/NcdLibrary',
                }
                return this.httpService.get(request);
        }
        allowUsertoUpdate(data) {
                var request = {
                        URL: 'document/master/setup/add/user',
                        DATA: data
                }
                return this.httpService.post(request);
        }

        getNCDUserAccessForEditFields(userId, docId) {
                var request = {
                        URL: 'document/master/setup/get/user/fields',
                        DATA: {
                                userId: userId,
                                doccumentId: docId
                        }
                }
                // userId: JSON.parse(localStorage.getItem('user'))._id
                return this.httpService.post(request);
        }
        getNCDUserFieldBy(loggedInUser) {
                var request = {
                        URL: 'document/master/setup/get/user/fields/for/user',
                        DATA: loggedInUser
                }
                // userId: JSON.parse(localStorage.getItem('user'))._id
                return this.httpService.post(request);
        }

        getIssue(isueId) {
                var request = {
                        URL: 'document/master/setup/get/user/issue/' + isueId,
                }
                return this.httpService.get(request);
        }

        upDateFields(data) {
                var request = {
                        URL: 'document/master/setup/user/fields/',
                        DATA: data
                };
                return this.httpService.post(request);
        }

        getDocumentBy(documentId) {
                var request = {
                        URL: 'document/master/setup/get/document/' + documentId,
                }
                return this.httpService.get(request);
        }

        getActiveUser(documentId) {
                var request = {
                        URL: 'document/master/setup/get/active/user/' + documentId,
                }
                return this.httpService.get(request);
        }
        getDocumentFields(documentId) {

                var request = {
                        URL: 'document/master/setup/add/ncd/fields/' + documentId,
                }
                return this.httpService.get(request);
        }
        saveSubDocuments(object) {
                var request = {
                        URL: 'document/master/setup/addSubDocuments',
                        DATA: object
                }
                return this.httpService.post(request);
        }
        saveDataEntryFields(object) {
                var request = {
                        URL: 'document/master/setup/addDataEntryFields',
                        DATA: object
                }
                return this.httpService.post(request);
        }
        getSubDocumentsByDocumentId(id) {
                var request = {
                        URL: 'document/master/setup/getSubDocumentsByDocId/' + id,
                }
                return this.httpService.get(request);
        }
        getSubDocumentsBySubDocumentId(id) {
                var request = {
                        URL: 'document/master/setup/getSubDocumentsBySubDocId/' + id,
                }
                return this.httpService.get(request);
        }
        deleteSubDocument(id) {
                var request = {
                        URL: 'document/master/setup/deleteSubDocument/' + id,
                }
                return this.httpService.get(request);
        }
        updateSubDocuments(object) {
                var request = {
                        URL: 'document/master/setup/updateSubDocuments',
                        DATA: object
                }
                return this.httpService.post(request);
        }
        reOrderingOfDocument(data, id) {
                var request = {
                        URL: "documentMaster/reOrderingOfDocuments/" + id,
                        DATA: data
                }
                return this.httpService.post(request)
        }
        addSubDocumentFile(data, subDocId) {
                var request = {
                        URL: "documentMaster/addSubDocumentFile/" + subDocId,
                        DATA: data
                }
                return this.httpService.post(request)
        }
        addDocumentTemplateFile(data, docId) {
                var request = {
                        URL: "documentMaster/addSubDocumentTemplateFile/" + docId,
                        DATA: data
                }
                return this.httpService.post(request)
        }
        exportDocument(issueId, documentId) {
                var request = {
                        URL: 'documentMaster/exportDocument/' + issueId + '/' + documentId,
                }
                return this.httpService.get(request);
        }

        downloadExportedDocument(issueId, documentId) {
                var token = localStorage.getItem('token')
                window.location.href = environment.pssServerUrl + 'documentMaster/downloadGeneratedDocument/' + issueId + '/' + documentId + '/' + token;
        }



        // ==================================================ALLOTTEES==============================================
        addAllottees(object) {
                var request = {
                        URL: 'ncdIssues/saveAllottee',
                        DATA: object
                }
                return this.httpService.post(request);
        }

        getAllAlloteesListData(object) {
                var issueListData = {
                        URL: "ncdAllotee/getList",
                        DATA: object
                }
                return this.httpService.post(issueListData);
        }

        addAllotteesMaster(object) {
                var request = {
                        URL: 'ncdAllotee/save',
                        DATA: object
                }
                return this.httpService.post(request);
        }

        updateAllotteesMaster(object, allotteeId){
                var request = {
                        URL: 'ncdAllotee/update/' + allotteeId,
                        DATA: object
                }
                return this.httpService.post(request);
        }

        getAlloteeDetails(allotteeId){
                var request = {
                        URL: 'ncdAllotee/getDetails/' + allotteeId,
                        // DATA: object
                }
                return this.httpService.get(request);
        }

        deleteCompanySpecificAllottees(allotteeId, investorCodeToDelete) {
                var request = {
                        URL: "ncdAllotee/delete/" + allotteeId + "/" + investorCodeToDelete
                }
                return this.httpService.get(request);
        }

        updateAllottees(object, allotteeId){
                var request = {
                        URL: 'ncdIssues/updateAllottee/' + allotteeId,
                        DATA: object
                }
                return this.httpService.post(request);
        }

        deleteIsssueSpecificAllottees(issueId, allotteeId) {
                var request = {
                        URL: "ncdIssues/deleteIssueSpecificAllottee/" + issueId + "/" + allotteeId
                }
                return this.httpService.post(request);
        }

        getExistingAllotteesList(){
                var request = {
                        URL: 'ncdIssues/getExistingAllotteesList',
                }
                return this.httpService.get(request);
        }

        getDetailsFromMasterByInvestorCode(allotteeId, investorCode){
                var request = {
                        URL: 'ncdIssues/AllotteeMaster/getDetailsByInvestorCode/' + allotteeId + "/" + investorCode,
                }
                return this.httpService.get(request);
        }

        getAllAllotteeListByIssueId(issueId, searchObj) {
                var request = {
                        URL: 'ncdIssues/getAllotteeListByIssueId/' + issueId,
                        DATA: searchObj
                }
                return this.httpService.post(request);
        }

        updateDocName(object) {
                var request = {
                        URL: 'document/master/setup/updateDocumentName',
                        DATA: object
                }
                return this.httpService.post(request);
        }
}
